module.exports = __webpack_public_path__ + "static/media/ApproveCardsNew.082cb298.svg";